import React from "react";
function Service () {
    return (

        <h2>Service</h2>
    )
    
}
export default Service;